import { render } from "./CellDateBatchDDM.vue?vue&type=template&id=389fa67c"
import script from "./CellDateBatchDDM.vue?vue&type=script&lang=js"
export * from "./CellDateBatchDDM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__